export const LANGUAGE = "Language";
export const AUTHORIZATION = "Authorization";
export const RETRY = "X-Retry";
